import {ComputedRef, InjectionKey} from "vue";

export const CURRENT_DIALOGS_AUDIO_INJECTION_KEY = Symbol() as InjectionKey<ComputedRef<HTMLAudioElement>>;
